var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternalLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A8A19B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.137 0H8.323c-.476 0-.863.387-.863.863s.387.863.863.863h2.73L6.5 6.28c-.163.163-.253.38-.253.61 0 .23.09.447.253.61.163.163.38.253.61.253.23 0 .447-.09.61-.253l4.555-4.555v2.73c0 .477.387.864.863.864S14 6.153 14 5.677V.863C14 .387 13.613 0 13.137 0z",
    transform: "translate(-183 -221) translate(183 221)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.918 12.52H1.479V4.083h6.347l1.48-1.48H.74c-.409 0-.74.332-.74.74v9.918c0 .409.331.74.74.74h9.918c.408 0 .74-.331.74-.74V4.695l-1.48 1.48v6.346z",
    transform: "translate(-183 -221) translate(183 221)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLink);
export default __webpack_public_path__ + "static/media/external_link.a89ea311.svg";
export { ForwardRef as ReactComponent };